export default defineNuxtPlugin(() => {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.ytmCuedOverlayPlayButton, ytm-cued-overlay-play-button').forEach(el => el.remove())
  })
  observer.observe(document.body, { childList: true, subtree: true })
})
